type CsvValue = string | number | null | undefined;

function escapeCsvValue(value: CsvValue): string {
  const text = value == null ? "" : String(value);
  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Déclenche le téléchargement d'un CSV lisible directement par Excel en français
 * (séparateur « ; », BOM UTF-8).
 */
export function downloadCsv(filename: string, rows: CsvValue[][]) {
  const content =
    "﻿" + rows.map((row) => row.map(escapeCsvValue).join(";")).join("\r\n");
  const url = URL.createObjectURL(
    new Blob([content], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
